/* eslint-disable */

import React from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import APIClient from "../client";
import {
  Button,
  OverlayTrigger,
  Popover,
  Spinner,
  Tabs,
  Tab,
  DropdownButton,
  Dropdown,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import Jobs from "./Jobs";

import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";

class LinkRaindancer extends React.Component {
  state = {
    showModal: false,
    account: null,
    username: "",
    password: "",
    customer_id: "",
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  async loadAccount() {
    try {
      await APIClient.get("/api/raindancer/irrigators/", null, cropr.cloudfarm_oauth_token).then(
        (response) => {
          this.setState({
            account: response,
          });
        }
      );
    } catch {
      this.setState({
        account: null,
      });
    }
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.id;
    this.setState({
      [name]: value,
    });
  };

  async saveAccount() {
    const formData = new FormData();
    formData.append("username", this.state.username);
    formData.append("password", this.state.password);
    formData.append("customer_id", this.state.customer_id);
    try {
      await APIClient.post(
        "/api/raindancer/account/",
        { formData: formData },
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Your account has been linked successfully."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Could not connect with the provided credentials."));
    }
  }

  async removeAccount() {
    try {
      await APIClient.remove("/api/raindancer/account/", null, cropr.cloudfarm_oauth_token).then(
        (response) => {
          cropr.notify("success", gettext("Your account has been deleted successfully."));
          this.loadAccount();
        }
      );
    } catch {
      cropr.notify("danger", gettext("Your account could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
  }

  render() {
    return (
      <>
        <a href="#" className="dropdown-item" onClick={() => this.toggle(true)}>
          {interpolate(gettext("Connect with %s"), ["Raindancer"])}
        </a>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              Raindancer account{" "}
              <img
                className="float-right"
                src="/static/assets/img/apps/raindancer.png"
                alt="Raindancer"
                style={{ height: "32px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey={this.state.account ? "tractors" : "account"}>
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.account ? (
                  <div>
                    <h4 className="mt-2">
                      {gettext("Currently linked account")}:&nbsp;
                      {this.state.account.username}/ {this.state.account.customer_id}
                    </h4>
                    <div className="mt-4">
                      <a className="btn btn-warning mr-1" onClick={() => this.removeAccount()}>
                        {gettext("Delete")}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div className="mt-2">
                    <Form onSubmit={() => this.saveAccount()}>
                      <Form.Group as={Row} controlId="username">
                        <Form.Label column sm={2}>
                          {gettext("Username")}
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            autoComplete="new-password"
                            placeholder={gettext("Username")}
                            value={this.state.username}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="customer_id">
                        <Form.Label column sm={2}>
                          {gettext("Client ID")}
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            autoComplete="new-password"
                            placeholder="Client ID"
                            value={this.state.customer_id}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} controlId="password">
                        <Form.Label column sm={2}>
                          {gettext("Password")}
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Control
                            autoComplete="new-password"
                            type="password"
                            placeholder="Password"
                            value={this.state.password}
                            onChange={this.handleInputChange}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row}>
                        <Col sm={{ span: 10, offset: 2 }}>
                          <Button type="submit">{gettext("Save")}</Button>
                        </Col>
                      </Form.Group>
                    </Form>
                  </div>
                )}
              </Tab>
              <Tab eventKey="tractors" title={gettext("Irrigators")} disabled={!this.state.account}>
                {this.state.account ? (
                  <Tractors
                    accountName={`${this.state.account.username}/${this.state.account.customer_id}`}
                    headers={[gettext("Name"), gettext("Radius")]}
                    tractors={this.state.account.irrigators.map((t, i) => ({
                      display: [t.name, t.radius],
                      serialNr: t.guid,
                      receiveOnly: true,
                    }))}
                    noActions={true}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="RD" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to Raindancer?")}</h5>
                <a href="https://raindancer.com" target="_blank">
                  https://raindancer.com
                </a>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkRaindancer;
